import { useState, useEffect } from 'react';
import { Box, MenuItem, FormHelperText } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
  CustomTextField,
  CustomSelect,
} from '../../../common/components';
import { useFeeTypes } from '../../../hooks/useFeeTypes';

const FeeTypeDialog = ({ open, onClose, onSave, selectedItem, editMode }) => {
  const { data: feeTypes = [] } = useFeeTypes();

  const [formData, setFormData] = useState({
    name: '',
    feeType: '',
    complete: '',
    score: '',
  });

  const [errors, setErrors] = useState({});
  const [saveAttempted, setSaveAttempted] = useState(false);

  useEffect(() => {
    if (open) {
      // Buscar el feeType correcto basado en el UUID
      let feeTypeValue = '';
      if (selectedItem?.uuid_fee_type) {
        // Buscar en feeTypes por UUID
        const matchingFeeType = feeTypes.find(ft => ft.uuid === selectedItem.uuid_fee_type);
        feeTypeValue = matchingFeeType ? matchingFeeType.name : '';
      }
      
      setFormData({
        name: selectedItem?.name || '',
        feeType: feeTypeValue,
        complete: selectedItem?.complete !== undefined ? selectedItem.complete.toString() : '',
        score: selectedItem?.score !== undefined ? selectedItem.score.toString() : '',
      });
      setErrors({});
      setSaveAttempted(false);
    }
  }, [open, selectedItem, feeTypes]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = true;
    }
    if (!formData.feeType) {
      newErrors.feeType = true;
    }
    if (!formData.complete) {
      newErrors.complete = true;
    }
    if (!formData.score) {
      newErrors.score = true;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    setSaveAttempted(true);

    if (validateForm()) {
      onSave(formData);
    }
  };

  return (
    <DialogContainer open={open} onClose={onClose} size="small">
      <DialogTitle>
        {editMode ? `Editar Tipo de Cuota: ${formData.name}` : 'Agregar Tipo de Cuota'}
      </DialogTitle>

      <DialogBody sx={{ display: 'block' }}>
        <Box>
          <Box sx={{ display: 'block' }}>
            <CustomTextField
              margin="dense"
              name="name"
              label="Nombre"
              type="text"
              fullWidth
              value={formData.name}
              onChange={handleInputChange}
              error={errors.name || (saveAttempted && !formData.name)}
            />
            {(errors.name || (saveAttempted && !formData.name)) && (
              <FormHelperText error>Debes ingresar un nombre.</FormHelperText>
            )}

            <CustomSelect
              label={'Tipo Cuota'}
              labelId="feeType-label"
              name="feeType"
              value={formData.feeType}
              onChange={handleSelectChange}
              error={errors.feeType || (saveAttempted && !formData.feeType)}
            >
              {feeTypes.map((feeType, index) => (
                <MenuItem key={index} value={feeType.name}>
                  {feeType.name}
                </MenuItem>
              ))}
            </CustomSelect>
            {(errors.feeType || (saveAttempted && !formData.feeType)) && (
              <FormHelperText error>Debes seleccionar un tipo de cuota.</FormHelperText>
            )}

            <CustomSelect
              label={'Completa'}
              labelId="complete-label"
              name="complete"
              value={formData.complete}
              onChange={handleSelectChange}
              error={errors.complete || (saveAttempted && !formData.complete)}
            >
              <MenuItem value="1">Si</MenuItem>
              <MenuItem value="0">No</MenuItem>
            </CustomSelect>
            {(errors.complete || (saveAttempted && !formData.complete)) && (
              <FormHelperText error>Debes seleccionar una opción para 'Completa'.</FormHelperText>
            )}

            <CustomSelect
              label={'Puntaje'}
              labelId="score-label"
              name="score"
              value={formData.score}
              onChange={handleSelectChange}
              error={errors.score || (saveAttempted && !formData.score)}
            >
              <MenuItem value="1">Si</MenuItem>
              <MenuItem value="0">No</MenuItem>
            </CustomSelect>
            {(errors.score || (saveAttempted && !formData.score)) && (
              <FormHelperText error>Debes seleccionar una opción para 'Puntaje'.</FormHelperText>
            )}
          </Box>
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={handleSave} />
    </DialogContainer>
  );
};

export default FeeTypeDialog;
